/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the image resource type to use.
 */
export var ImageResourceType = /*@__PURE__*/ (function (ImageResourceType) {
    /**
     * Image resource type will attempt to be determined from any scheme specifiers on the paths.
     */
    ImageResourceType[ImageResourceType["Unspecified"] = 0] = "Unspecified";
    /**
     * Images are a local platform specific resource in the application.
     */
    ImageResourceType[ImageResourceType["LocalResource"] = 1] = "LocalResource";
    /**
     * Images are a local platform specific asset in the application. For platforms that don't support assets, this will fall back on local resource.
     */
    ImageResourceType[ImageResourceType["LocalAsset"] = 2] = "LocalAsset";
    /**
     * Images are a .NET embedded resource in the application. Path needs to be a valid embedded resource identifier.
     */
    ImageResourceType[ImageResourceType["EmbeddedResource"] = 3] = "EmbeddedResource";
    /**
     * Images are a remote URL resource.
     */
    ImageResourceType[ImageResourceType["RemoteResource"] = 4] = "RemoteResource";
    return ImageResourceType;
})({});
/**
 * @hidden
 */
export var ImageResourceType_$type = /*@__PURE__*/ markEnum('ImageResourceType', 'Unspecified,0|LocalResource,1|LocalAsset,2|EmbeddedResource,3|RemoteResource,4');
//# sourceMappingURL=ImageResourceType.js.map
